<template>
    <b-overlay :show="loading" rounded="sm" v-if="documents.length > 0">

        <div class="h5">
            Textos Motivadores
            <span v-b-tooltip.hover title="Este é o texto motivador enviado pelo aluno quando ele selecionou tema livre">
                <i class="fas fa-xs fa-info-circle"></i>
            </span>
        </div>

        <b-card v-if="essay" class="mb-3">

            <table class="table table-sm">
                <tr>
                    <td>
                        Arquivo
                    </td>
                    <td>
                        Ações
                    </td>
                </tr>
                <tr v-for="documentItem in documents" :key="documentItem.id">
                    <td>
                        <div v-if="documentItem.extension === 'pdf'" class="document-file">
                            <span class="fas fa-file-pdf mr-1"></span>
                            {{ documentItem.name }}
                        </div>
                        <div v-else>
                            <img :src="documentItem.preview" class="img-thumbnail" width="60px" height="60px" alt="Preview"/>
                        </div>
                    </td>
                    <td class="d-flex align-items-center">
                        <div v-if="documentItem.extension === 'pdf'">
                            <a :href="documentItem.preview" target="_blank">
                                <span class="fas fa-eye mr-1"></span> Ver PDF
                            </a>
                        </div>
                        <div v-else>
                            <a href="javascript:void(1)" @click="showFullscreen(documentItem.preview)">
                                <span class="fas fa-eye mr-1"></span> Ver Imagem
                            </a>
                        </div>
                    </td>
                </tr>
            </table>
        </b-card>

        <!-- Modal Preview -->
        <b-modal id="previewDocument" title="Prévia" size="xl" hide-footer>
            <div v-if="preview" class="text-center">
                <img :src="preview" class="img-thumbnail"/>
            </div>
        </b-modal>

    </b-overlay>
</template>

<script>
export default {
    props: ['essay'],
    data() {
        return {
            loading: false,
            documents: [],
            preview: null,
        }
    },
    created() {

        // Load
        this.load()

    },
    methods: {

        load() {
            this.loading = true;
            axios.get('/teacher/essay-documents/' + this.essay.id)
                .then((result) => {
                    const response = result.data.data;
                    if (response.documents) {
                        this.documents = response.documents
                    }
                })
                .finally(() => this.loading = false)
        },

        showFullscreen(preview) {
            this.preview = preview;
            this.$bvModal.show('previewDocument');
        }

    }
}
</script>

<style scoped>
    .document-file {
        width: 70px;
        text-transform: capitalize;
    }
</style>
